{
    "main_h1": "News from and for Zurich",
    "date_published": "Published",
    "date_modified": "Last updated",
    "back_to_feed": "Back to overview",
    "PROMOTION": "Promotion",
    "SOCIETY": "Society",
    "FREETIME": "Leisure",
    "NEWS": "Latest"
}